<div class="location-module flex-col">
  <ui-header-with-breadcrumbs>
    <app-global-search-trigger></app-global-search-trigger>
    <app-location-view-tabs [activeViewType]="viewType$ | async"></app-location-view-tabs>
  </ui-header-with-breadcrumbs>
  <div class="w-100 h-100 min-h-0">
    <router-outlet></router-outlet>
  </div>
</div>
